export default __webpack_public_path__ + "static/generali-a9bfb8d66a45fba2746b2253424a32f1.png";